export default (positionTypes) => {
    let names = positionTypes.map(({name}) => name)
    return names.length > 0 ? names.join(', ') : null
}
